import RestBase from '@/services/base/RestBase'
import { ApiEnum } from '@/constants/ApiEnum'

export default class LogradouroService  extends RestBase {
    constructor() {
        super(ApiEnum.BACKEND, '/citsbe/recarga', 2);
    }

    async getListaLogradouro() {
        return this.get(`/tipoLogradouro/findAll`);
    } 
}